import styled from 'styled-components';
import { theme } from '../../themes/default';
import { respondTo } from '../../utils/breakpoints';

export const Testimonial = styled.div`
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding-bottom: 20px;
`;

export const TestimonialImage = styled.img`
  border-radius: 50%;
  width: 200px;
  height: auto;
  aspect-ratio: 1/1;
  object-fit: cover;
  object-position: top;
  border: 5px solid ${(props) => props.theme.colors.uiBlue};
  &:nth-of-type(2) {
    object-position: center center !important;
  }
`

export const TestimonialName = styled.h4`
  text-align: center;
  font-size: 18px;
  color: ${(props) => props.theme.colors.uiDarkBlue};
`
export const TestimonialTitle = styled.h5`
  font-size: 16px;
  text-transform: none !important;
  text-align: center !important;
  letter-spacing: normal !important;
  margin: 8px 0 !important; 
`
export const TestimonialText = styled.p`
  ${respondTo.xs`
    text-align: center;
  `}
`

export const TestimonialsWrapper = styled.div`
  width: 100%;
  padding-top: 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`
export const TestimonialsBody = styled.div`
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  flex-direction: column;
  width: 100%;
  gap: 24px;
  ${Testimonial} {
    flex-basis: calc(25% - 24px);
    width: 100%;
  }
  ${respondTo.m`
    flex-direction: row;
    align-items: space-around;ś
  `}
`